export const SENSITIVE_FIELD_SHIELD_MESSAGE = 'Sensitive field - only visible to roles with access';

export const SENSITIVE_VARIABLE_TOOLTIP_MESSAGE = 'Permission required to view this sensitive field.';
